<script>
	import { isVideoFile, splitCamelCaseAndCapitalize } from "src/utils/misc";
	import Lightbox from "../Lightbox/Lightbox.svelte";
	import { imageLightbox } from "src/store/store";
	import VideoThumbnail from "../VideoPlayer/VideoThumbnail.svelte";

	export let data;
	export let title = "";
	export let lightbox = false;
	export let boxes = []; // [x1, x2, y1, y2]
	export let origShape = []; // [Height, Width]
	export let damageAttributionEnabled = false;
	export let showImageTitle = true;

	let idx = 0;
	let isOpen = false;

	let isPrevDisabled = false;
	let isNextDisabled = false;
	let imageError = false;

	// update disabled state of left/right chevrons based on image index
	$: isPrevDisabled = idx === 0; // true if at first image
	$: isNextDisabled = data?.images ? idx === data.images.length - 1 : true; // true if at last image

	function handleOpenLightBox(i, image) {
		imageLightbox.set([]);
		idx = Number(i);
		isOpen = true;
		imageLightbox.set(image.map((img) => img.imgUrl));
	}

	function setIndex(i) {
		idx = i;
	}

	$: if (idx) {
		data.images[idx].isDamage = data.images[idx].isDamage || false;
	}
</script>

{#if isOpen && lightbox}
	<Lightbox
		on:click={() => {
			isOpen = false;
		}}
		{idx}
	/>
{/if}
<div class="d-flex flex-column p-3 mr-1" style="height: fit-content;">
	<h4 class="d-flex justify-content-center w-100 my-2">
		<b> {title} </b>
	</h4>

	<div style="height: 80%;">
		<div class="d-flex justify-content-center w-100 my-2">
			{showImageTitle && data.images && data.images.length > 0
				? splitCamelCaseAndCapitalize(data.images[idx].imgSide)
				: ""}
		</div>
		<div
			class="d-flex justify-content-center w-100 my-2 damage-image-container"
		>
			<img
				src="/assets/icon-chevron-left-thin.svg"
				alt="left-arrow"
				class="arrow {isPrevDisabled ? 'arrow-disabled' : ''}"
				as="button"
				on:click={() => {
					if (idx > 0) {
						idx--;
					}
				}}
				on:keydown={() => {}}
			/>
			<div
				on:click={() => handleOpenLightBox(idx, data.images)}
				on:keydown={() => {}}
				class="image-wrapper"
			>
				{#if data.images && data.images.length > 0}
					<div class="image-wrapper">
						{#if !isVideoFile(data.images[idx].imgUrl)}
							<img
								src={data.images[idx].imgUrl}
								alt={idx + " side thumbnail"}
								class="damage-image"
								style={data.images[idx].isDamage
									? "border: 2px solid red;"
									: ""}
							/>
						{:else}
							<!-- Replace 'ImageErrorComponent' with your actual error component -->
							<VideoThumbnail url={data.images[idx].imgUrl} />
						{/if}
						{#if boxes.length > 0 && origShape.length > 0}
							{#each boxes as box}
								<span
									class="bounding-box"
									style="
                                        left: {(box[0] / origShape[1]) * 100}%;
						top: {(box[2] / origShape[0]) * 100}%;
						width: {((box[1] - box[0]) / origShape[1]) * 100}%;
						height: {((box[3] - box[2]) / origShape[0]) * 100}%;"
								/>
							{/each}
						{/if}
						{#if data.images[idx].isDamage}
							<img
								src="/assets/icon-alert-filled-red.svg"
								alt="alert"
								class="alert-icon-thumb"
							/>
						{/if}
					</div>
				{/if}
			</div>
			<img
				src="/assets/icon-chevron-right-thin.svg"
				alt="right-arrow"
				class="arrow {isNextDisabled ? 'arrow-disabled' : ''}"
				as="button"
				on:click={() => {
					if (idx < data.images.length - 1) {
						idx++;
					}
				}}
				on:keydown={() => {}}
			/>
		</div>
		<div class="d-flex align-items-center justify-content-center">
			<div class="d-flex flex-column">
				<label class="radio-option px-5">
					<input
						type="radio"
						value={false}
						checked
						on:change={() => {
							data.images[idx].isDamage = false;
						}}
						bind:group={data.images[idx].isDamage}
					/>
					<span>No new damage in this photo</span>
				</label>
				<label class="radio-option px-5">
					<input
						type="radio"
						value={true}
						on:change={() => {
							data.images[idx].isDamage = true;
						}}
						bind:group={data.images[idx].isDamage}
					/>
					<span>New damage in this photo</span>
				</label>
			</div>
		</div>
		<div
			class="d-flex align-items-end justify-content-center desc-container"
		>
			{#if data.images && data.images.length > 0}
				{#each data.images as image, i}
					<div class="image-thumbnail-wrapper">
						{#if !isVideoFile(image.imgUrl)}
							<img
								src={image.imgUrl}
								alt={i + " side thumbnail"}
								class="damages-image"
								style={image.isDamage
									? "border: 2px solid red;"
									: ""}
								on:click={() => {
									setIndex(i);
								}}
								on:keydown={() => {}}
							/>
						{:else}
							<VideoThumbnail
								url={image.imgUrl}
								className="damages-image"
								onClick={() => {
									setIndex(i);
								}}
								selected={image.isDamage}
								onKeyDown={() => {}}
							/>
						{/if}
					</div>
					{#if image.isDamage}
						<span
							style="position: relative; display: inline-block;"
						>
							<img
								src="/assets/icon-alert-filled-red.svg"
								alt="alert"
								class="alert-icon"
							/>
						</span>
					{/if}
				{/each}
			{/if}
		</div>
	</div>
</div>

<style>
	.image-thumbnail-wrapper {
		position: relative;
		display: inline-block;
		margin: 0 2px;
		cursor: pointer;
	}

	.alert-icon {
		position: absolute;
		top: -62px;
		right: -7px;
		width: 24px;
		height: 24px;
		z-index: 2;
	}

	.image-wrapper {
		position: relative;
		display: inline-block;
	}
	.description {
		color: var(--fds-on-surface-variant);
	}

	.review-container {
		border: 1px solid #e8e8e8;
		border-radius: 8px;
	}

	.info-category {
		border-bottom: 1px solid #e8e8e8;
	}

	.damage-image-container {
		height: 90%;
	}

	.damage-image {
		height: 410px;
		width: 100%;
		object-fit: cover;
		display: block;
		max-width: 100%;
	}

	:global(.damages-image) {
		height: 50px;
		width: 50px;
		margin: 0 2px;
		display: block;
	}

	img:hover {
		cursor: pointer;
	}
	.arrow {
		width: 30px;
		margin: 0 10px;
	}

	.desc-container {
		margin: 36px 0;
	}

	.arrow-disabled {
		opacity: 0.5;
		pointer-events: none;
	}
</style>
